<template>
    <div>
        <h3>这是什么，字体,呢</h3>
        <p class="p">这是什么，字体,呢</p>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        test: 1
      }
    },
    components: {},
    created () {},
    mounted () {},
    methods: {}
  }
</script>

<style lang="scss" scoped>
.p {
    font-size: 16px;
    font-family: PingFang SC, "Helvetica Neue", Arial, sans-serif;
    background-color: #f7f8fa;
    -webkit-font-smoothing: antialiased;
}
</style>
